export default "__VITE_ASSET__DRYVae7S__"